import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";

function Infodrawer({ data }) {
  function Datarow({ cell }) {
    if (data[cell])
      return (
        <div className="datarow">
          <div className="datacell">{cell} </div>
          <div className="datacell">{data[cell]} </div>
        </div>
      );
    else return "";
  }
  if (data)
    return (
      <div className="info">
        <Grid container spacing={4}>
          <Grid item sm={12} md={6}>
            <div>
              <h2>{data.Engine}</h2>
              <div>
                {data["Image Name"] ? (
                  <img
                    src={"./images/" + data["Image Name"]}
                    alt={data.Engine}
                    width="100%"
                  />
                ) : null}
              </div>
              <div className="datalist">
                <Datarow cell="Parent Engine" />
                <Datarow cell="First Engine Test" />
                <Datarow cell="Entry Into Service" />
              </div>

              <div className="datalist">
                <Datarow cell="Fan Diameter" />
              </div>
            </div>
          </Grid>

          <Grid item sm={12} md={6}>
            <h2>KEY ENGINE DATA</h2>
            <div className="datalist">
              <Datarow cell="Engine" />
              <Datarow cell="Fan Stages" />
              <Datarow cell="Booster Stage" />
              <Datarow cell="High Pressure Compressor Stages" />
              <Datarow cell="Combustor Type" />
            </div>

            <div className="datalist">
              <Datarow cell="High Pressure Turbine Stages" />
              <Datarow cell="Low Pressure Turbine Stages" />
              <Datarow cell="Take-Off Pressure Ratio" />
              <Datarow cell="Engine Bypass Ratio" />
              <Datarow cell="Take-Off Thrust" />
            </div>

            <div className="datalist">
              <Datarow cell="Take-Off Airflow" />
            </div>
            <div className="datalist">
              <Datarow cell="Total Manufactured" />
              <Datarow cell="Applications" />
              <Datarow cell="Awards, Records, Significance, Innovations" />
              <Datarow cell="Type" />
            </div>
          </Grid>
        </Grid>
        {/* <div id="pagecontrols">
          <div id="btnnext">></div>
          <div id="btnprevious">&lt;</div>
        </div> */}
      </div>
    );
  else return <div />;
}

Infodrawer.propTypes = {
  data: PropTypes.object
};

export default Infodrawer;
